import crmService from '@/services/crm_service'
import { recursiveAssign } from '@/utils'

const state = {
  users: { data: [] }
}

const mutations = {
  'SET_USER' (state, data) {
    verify(state, data)
  },
  'SET_USERS' (state, users) {
    state.users = users
  }
}

const actions = {
  getUser ({ commit }, id) {
    crmService.getUser(id, user => commit('SET_USER', user))
  },
  getUsers ({ commit }) {
    crmService.getUsers(users => commit('SET_USERS', users))
  }
}

const getters = {
  user: (state) => (id) => {
    return state.users.data.find(obj => obj.id === id) || { attributes: {} }
  }
}

function verify (state, user) {
  const existing = state.users.data.find(item => item.id === user.id)
  if (!existing) state.users.data.push(user)
  else recursiveAssign(existing, user)
}

export default {
  state,
  mutations,
  actions,
  getters
}
